import { Dialog } from "@mui/material";
import React, { useState, memo } from "react";

import { useTranslation } from "react-i18next";
import { Props } from "./interfaces";
import { DialogContent, InfoContainer, IntervalContainer, TextMessage } from "./styles";

import DialogTitle from "../../../containers/DialogTitle/DialogTitle";

const weekDays = ["Monday", "Thuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const ScheduleDetailsModal = ({ intervals, name, code, description, children }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.my_calendar";

  const [open, setOpen] = useState<boolean>(false);
  // const [loading, setLoading] = useState<boolean>(false);

  const withZeroDateNumber = (number: number) => {
    if (number === 0) return "00";

    return number < 10 ? `0${number}` : `${number}`;
  };

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        style={{ width: "100%" }}
      >
        {children}
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle
          title={t(`${tRP}.schedule`)}
          handleClose={() => setOpen(false)}
        />
        {/* <LoadingOverlay loading={loading}> */}
        <DialogContent>
          {intervals?.length === 0 ? (
            <TextMessage>There are no intervals</TextMessage>
          ) : (
            <InfoContainer>
              <span className="info">
                Code: <span className="info_description">{code?.trim() ? code : "<?>"}</span>
              </span>
              <span className="info">
                Name: <span className="info_description">{name}</span>
              </span>
              <span className="info">
                Description: <span className="info_description">{description}</span>
              </span>

              {weekDays.map((day, i) => {
                const filteredIntervals = intervals
                  ?.filter((interval, idx) => interval.weekDay === i + 1)
                  .sort((a, b) => (a.startHour > b.startHour ? 1 : a.startHour < b.startHour ? -1 : 0));
                if (filteredIntervals && !!filteredIntervals.length) {
                  return (
                    <React.Fragment key={i}>
                      <span className="info_day">{day}</span>
                      {filteredIntervals.map((interval, index) => (
                        <IntervalContainer key={index}>
                          <span>
                            {withZeroDateNumber(interval.startHour)}:{withZeroDateNumber(interval.startMinute)} -{" "}
                            {withZeroDateNumber(interval.endHour)}:{withZeroDateNumber(interval.endMinute)}
                          </span>
                        </IntervalContainer>
                      ))}
                    </React.Fragment>
                  );
                }
              })}
            </InfoContainer>
          )}
        </DialogContent>
        {/* </LoadingOverlay> */}
      </Dialog>
    </>
  );
};

export default memo(ScheduleDetailsModal);
